import Layout from '@/layout'

const PriceRouter = {
  path: '/Price',
  component: Layout,
  redirect: 'noredirect',
  name: 'Price',
  meta: {
    title: 'Price',
    icon: 'daohang-ziliaoguanli',
    roles: []
  },
  children: [
    {
      path: 'PriceReal',
      component: () => import('@/views/cargo/v0/Price/PriceReal/index'),
      name: 'PriceReal',
      meta: { title: '运价查询' },
      roles: ['module_PRPriceReal']
    },
    {
      path: 'PriceFCLReal',
      component: () => import('@/views/cargo/v0/Price/PriceFCLReal/index'),
      name: 'PriceFCLReal',
      meta: { title: '整箱运价查询' },
      roles: ['module_PRPriceFCLReal']
    },
    {
      path: 'PriceFCL',
      component: () => import('@/views/cargo/v0/Price/PriceFCL/index'),
      name: 'PriceFCL',
      meta: { title: '整箱运价输入' },
      roles: ['module_PRPriceFCL']
    },
    {
      path: 'Quotation',
      component: () => import('@/views/cargo/v0/Price/Quotation/index'),
      name: 'Quotation',
      meta: { title: '报价管理' },
      roles: ['module_PRQuotation']
    },
    {
      path: 'TariffTable',
      component: () => import('@/views/cargo/v0/Price/TariffTable/index'),
      name: 'TariffTable',
      meta: { title: '运价表' },
      roles: ['module_PRTariffTable']
    },
    {
      path: 'SurchargeFCL',
      component: () => import('@/views/cargo/v0/Price/SurchargeFCL/index'),
      name: 'SurchargeFCL',
      meta: { title: '整箱附加费维护' },
      roles: ['module_SurchargeFCL']
    },
    {
      path: 'PriceFCLExtra',
      component: () => import('@/views/cargo/v0/Price/PriceFCLExtra/index'),
      name: 'PriceFCLExtra',
      meta: { title: '整箱附加信息维护' },
      roles: ['module_PRPriceFCLExtra']
    },
    {
      path: 'PriceLCLReal',
      component: () => import('@/views/cargo/v0/Price/PriceLCLReal/index'),
      name: 'PriceLCLReal',
      meta: { title: '拼箱运价查询' },
      roles: ['module_PRPriceLCLReal']
    },
    {
      path: 'PriceAirReal',
      component: () => import('@/views/cargo/v0/Price/PriceAirReal/index'),
      name: 'PriceAirReal',
      meta: { title: '空运运价查询' },
      roles: ['module_PRPriceAirReal']
    },
    {
      path: 'ShippingSchedule',
      component: () => import('@/views/cargo/v0/Price/ShippingSchedule/index'),
      name: 'ShippingSchedule',
      meta: { title: '整箱船期管理' },
      roles: ['module_PRShippingSchedule']
    },
    {
      path: 'PriceFCLStat',
      component: () => import('@/views/cargo/v0/Price/PriceFCLStat/index'),
      name: 'PriceFCLStat',
      meta: { title: '整箱运价统计' },
      roles: ['module_PRPriceFCLStat']
    },
    {
      path: 'PriceFCLLog',
      component: () => import('@/views/cargo/v0/Price/PriceFCLLog/index'),
      name: 'PriceFCLLog',
      meta: { title: '整箱运价历史' },
      roles: ['module_PRPriceFCLLog']
    },
    {
      path: 'PriceAir',
      component: () => import('@/views/cargo/v0/Price/PriceAir/index'),
      name: 'PriceAir',
      meta: { title: '空运运价输入' },
      roles: ['module_PRPriceAir']
    },
    {
      path: 'PriceFclAddon',
      component: () => import('@/views/cargo/v0/Price/PriceFclAddon/index'),
      name: 'PriceFclAddon',
      meta: { title: '整箱Addon运价输入' },
      roles: ['module_PRPriceFclAddon']
    },
    {
      path: 'QuotationFcl',
      component: () => import('@/views/cargo/v0/Price/QuotationFcl/index'),
      name: 'QuotationFcl',
      meta: { title: '整箱报价管理' },
      roles: ['module_PRQuotationFCL']
    },
    {
      path: 'PriceFCLShare',
      component: () => import('@/views/cargo/v0/Price/PriceFCLShare/index'),
      name: 'PriceFCLShare',
      meta: { title: '整箱运价分享' },
      roles: ['module_PRPriceFCLShare']
    },
    {
      path: 'PriceWeightLimit',
      component: () => import('@/views/cargo/v0/Price/PriceWeightLimit/index'),
      name: 'PriceWeightLimit',
      meta: { title: '整箱限重信息' },
      roles: ['module_PriceWeightLimit']
    },
    {
      path: 'PriceLclAddon',
      component: () => import('@/views/cargo/v0/Price/PriceLclAddon/index'),
      name: 'PriceLclAddon',
      meta: { title: '拼箱Addon运价输入' },
      roles: ['module_PRPriceLclAddon']
    },
    {
      path: 'PriceLCL',
      component: () => import('@/views/cargo/v0/Price/PriceLCL/index'),
      name: 'PriceLCL',
      meta: { title: '拼箱运价输入' },
      roles: ['module_PRPriceLCL']
    },
    {
      path: 'QuotationClient',
      component: () => import('@/views/cargo/v0/Price/QuotationClient/index'),
      name: 'QuotationClient',
      meta: { title: '报价客户管理' },
      roles: ['module_QuotationClientMaintence']
    },
    {
      path: 'QuotationAir',
      component: () => import('@/views/cargo/v0/Price/QuotationAir/index'),
      name: 'QuotationAir',
      meta: { title: '空运报价管理' },
      roles: ['module_PRQuotationAir']
    },
    {
      path: 'PriceFCLSubscribe',
      component: () => import('@/views/cargo/v0/Price/PriceFCLSubscribe/index'),
      name: 'PriceFCLSubscribe',
      meta: { title: '整箱订阅管理' },
      roles: ['module_PRPriceFCLSubscribe']
    },
    {
      path: 'QuotationLcl',
      component: () => import('@/views/cargo/v0/Price/QuotationLcl/index'),
      name: 'QuotationLcl',
      meta: { title: '拼箱报价管理' },
      roles: ['module_PRQuotationLCL']
    },
    {
      path: 'PODCharge',
      component: () => import('@/views/cargo/v0/Price/PODCharge/index'),
      name: 'PODCharge',
      meta: { title: '拼箱目的港收费输入' },
      roles: ['module_PRPricePODCharge']
    },
    {
      path: 'AirFlightInformationManagement',
      component: () => import('@/views/cargo/v0/Price/AirFlightInformationManagement/index'),
      name: 'FrightSurCharge',
      meta: { title: '空运航班信息管理' },
      roles: ['module_PRAirFlightInformationManagement']
    },
    {
      path: 'FrightSurCharge',
      component: () => import('@/views/cargo/v0/Price/FrightSurCharge/index'),
      name: 'FrightSurCharge',
      meta: { title: '空运附加费输入' },
      roles: ['module_FrightSurCharge']
    },
    {
      path: 'PriceAirShare',
      component: () => import('@/views/cargo/v0/Price/PriceAirShare/index'),
      name: 'PriceAirShare',
      meta: { title: '空运运价分享' },
      roles: ['module_PRPriceAirShare']
    },
    {
      path: 'PriceAirSubscribe',
      component: () => import('@/views/cargo/v0/Price/PriceAirSubscribe/index'),
      name: 'PriceAirSubscribe',
      meta: { title: '空运订阅管理' },
      roles: ['module_PRPriceAirSubscribe']
    },
    {
      path: 'PriceLCLShare',
      component: () => import('@/views/cargo/v0/Price/PriceLCLShare/index'),
      name: 'PriceLCLShare',
      meta: { title: '拼箱运价分享' },
      roles: ['module_PRPriceLCLShare']
    },
    {
      path: 'PriceAirStat',
      component: () => import('@/views/cargo/v0/Price/PriceAirStat/index'),
      name: 'PriceAirStat',
      meta: { title: '空运运价统计' },
      roles: ['module_PRPriceAirStat']
    },
    {
      path: 'PriceAirLog',
      component: () => import('@/views/cargo/v0/Price/PriceAirLog/index'),
      name: 'PriceAirLog',
      meta: { title: '空运运价历史' },
      roles: ['module_PRPriceAirLog']
    },
    {
      path: 'ShippingContract',
      component: () => import('@/views/cargo/v0/Price/ShippingContract/index'),
      name: 'ShippingContract',
      meta: { title: '船公司约号管理' },
      roles: ['module_ShippingContract']
    },
    {
      path: 'PricePrePort',
      component: () => import('@/views/cargo/v0/Price/PricePrePort/index'),
      name: 'PricePrePort',
      meta: { title: '港前运价维护' },
      roles: ['module_PricePrePort']
    },
    {
      path: 'PriceLastMile',
      component: () => import('@/views/cargo/v0/Price/PriceLastMile/index'),
      name: 'PriceLastMile',
      meta: { title: '尾程运价维护' },
      roles: ['module_PriceLastMile']
    },
    {
      path: 'Inquiry',
      component: () => import('@/views/cargo/v0/Price/Inquiry/index'),
      name: 'Inquiry',
      meta: { title: '询价管理' },
      roles: ['module_Inquiry']
    }
  ]
}

export default PriceRouter
